<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { mapState } from 'vuex';
export default {
  name: "AddressAutocomplete",
  props: {
    streetAddress: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Autocomplete
  },
  data() {
    return {
      googleAutocomplete: null,
      placesService: null,
      addressData: {
        line_1: null,
        city: null,
        zip: null,
        latitude: null,
        longitude: null,
        state_id: null,
        county_id: null,
      },
    }
  },
  computed: {
    countiesForState() {
      if(!this.addressData.state_id) return [];

      return _.filter(this.counties, county => county.state_id === this.addressData.state_id);
    },
    ...mapState('App', ['states', 'counties'])
  },
  mounted() {

    if(this.streetAddress) {
      // this.$refs['autocomplete-input'].value = this.streetAddress;
    }

    this.googleAutocomplete = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
  },
  methods: {
    setAddressLine1($event) {
      this.addressData.line_1 = $event.target.value;
    },
    async search(term) {
      if(term.length < 2) return [];
      let r = await this.getGoogleResults(term);
      return r;
    },
    getGoogleResults(term) {
      return new Promise((resolve, reject) => {
        this.googleAutocomplete.getPlacePredictions({
          input: term,
          types: ['address'],
        }, resolve)
      })
    },
    getAddressValue(result) {
      return result.description;
    },
    setAddress(result) {
      // Get Place Details
      this.placesService.getDetails({ placeId: result.place_id}, place => {

        let numberComponent = this.getPlaceComponentByType(place, 'street_number');
        let streetComponent = this.getPlaceComponentByType(place, 'route');
        let cityComponent = this.getPlaceComponentByType(place, 'locality');
        if(!cityComponent) {
          cityComponent = this.getPlaceComponentByType(place, 'administrative_area_level_3');
        }
        let countyNameComponent = this.getPlaceComponentByType(place, "administrative_area_level_2");
        let stateAbbrComponent = this.getPlaceComponentByType(place, 'administrative_area_level_1');
        let zipComponent = this.getPlaceComponentByType(place, 'postal_code');


        let number = numberComponent ? numberComponent.long_name : '';
        let street = streetComponent ? streetComponent.short_name : '';
        let city = cityComponent ? cityComponent.long_name : '';
        let countyName = countyNameComponent ? countyNameComponent.long_name : '';
        let stateAbbr = stateAbbrComponent ? stateAbbrComponent.short_name : '';
        let zip = zipComponent ? zipComponent.short_name : '';

        this.$refs.addressAutocomplete.value = number + ' ' + street;
        this.addressData.line_1 = number + ' ' + street;
        this.addressData.city = city;
        this.addressData.zip = zip;
        this.addressData.latitude =  place.geometry.location.lat();
        this.addressData.longitude =  place.geometry.location.lng();
        this.addressData.state_id = this.getStateIdFromAbbr(stateAbbr);
        this.addressData.county_id = this.getCountyIdFromName(countyName);
        this.$emit('updated', this.addressData);

        //lock the county field when inputting address
        //document.getElementById('county_field').setAttribute('disabled', 'disabled');
      })
    },
    getStateIdFromAbbr(stateAbbr) {
      for(var i in this.states) {
        if(this.states[i].state_acronym === stateAbbr) {
          return this.states[i].id;
        }
      }
    },

    getCountyIdFromName(countyName) {
      for(var i in this.countiesForState) {
        let county = this.countiesForState[i];
        if(county.county_name === countyName) {
          return county.id;
        }
        let shortName = countyName.replace(' County', '');
        if(county.county_name === shortName) {
          return county.id;
        }
      }
    },
    getPlaceComponentByType(place, type) {
      for(var i in place.address_components) {
        for(var j in place.address_components[i].types) {
          if(place.address_components[i].types[j] === type) {
            return place.address_components[i];
          }
        }
      }
    },
  }
}
</script>

<template>
<div>
  <autocomplete
      :placeholder="__('global.street_address')"
      ref="addressAutocomplete"
      class="inline-autocomplete"
      :default-value="streetAddress"
      :search="search"
      :debounce-time="500"
      :get-result-value="getAddressValue"
      :aria-disabled="disabled"
      autocomplete="off"
      @blur="setAddressLine1"
      @submit="setAddress"
  >
    <template
        #default="{
                        rootProps,
                        inputProps,
                        inputListeners,
                        resultListProps,
                        resultListListeners,
                        results,
                        resultProps
                        }"
    >
      <div v-bind="rootProps">
        <input
            v-bind="inputProps"
            v-on="inputListeners"
            :disabled="disabled"
            :placeholder="placeholder"
            :class="[
                                'autocomplete-input',
                                { 'autocomplete-input-no-results': noResults },
                                { 'autocomplete-input-focused': focused }
                                ]"
            ref="autocomplete-input"
        />
        <ul
            v-if="noResults"
            class="autocomplete-result-list"
            style="position: absolute; z-index: 1; width: 100%; top: 100%;"
        >
          <li class="autocomplete-result">
            No results found
          </li>
        </ul>
        <ul v-bind="resultListProps" v-on="resultListListeners">
          <li
              v-for="(result, index) in results"
              :key="resultProps[index].id"
              v-bind="resultProps[index]"
          >
            {{ result.description }}
          </li>
        </ul>
      </div>
    </template>
  </autocomplete>
</div>
</template>

<style scoped lang="scss">

</style>